import { ICellRendererParams } from 'ag-grid-community'
import { useMemo } from 'react'

import { useQuickFilterHighlights } from '@/lib/ui/quick-filter-highlights.hook'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

import { HighlightedText } from '@/components/lemmala-design-system/highlighted-text/highlighted-text'

export const ControlCell = ({ data }: ICellRendererParams<ControlRow>) => {
  const { getHighlights } = useQuickFilterHighlights()

  const { titleHighlights, descriptionHighlights, isGroupedControl } = useMemo(
    () => ({
      titleHighlights: getHighlights(data?.title || ''),
      descriptionHighlights: getHighlights(data?.description || ''),
      isGroupedControl: data?.isGroupedControl,
    }),
    [data, getHighlights],
  )

  if (!data) return null

  return (
    <div className={`${isGroupedControl ? 'pl-10' : ''} flex flex-col gap-0 truncate`}>
      <div className='text-main-foreground-primary text-body-default'>
        <HighlightedText text={data?.title} highlights={titleHighlights} />{' '}
      </div>
      <span className='truncate text-main-foreground-secondary text-body-small'>
        <HighlightedText text={data?.description} highlights={descriptionHighlights} />
      </span>
    </div>
  )
}
